// @flow
// eslint-disable-next-line import/prefer-default-export
export { default as withInfiniteLoader } from './withInfiniteLoader';
